import { Component } from '@angular/core';
import { BaseSitesFacade } from '@kion/data-access/data-access-base-sites';
import { CmsConfig } from '../../config/cms.config';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BaseSite } from '@kion/data-models';
import { map } from 'rxjs/operators';
import { Contact } from '../../../../../lr-ui/src/lib/elements/contact-box/contact-box.component';

@Component({
  selector: 'kion-cms-contact-box',
  templateUrl: './contact-box.component.html',
  styleUrls: ['./contact-box.component.scss']
})
export class ContactBoxComponent {

  contacts$: Observable<Contact[]>;

  constructor(private baseSitesFacade: BaseSitesFacade, private cmsConfig: CmsConfig, private translateService: TranslateService) {
    this.contacts$ = this.baseSitesFacade.all$.pipe(
      map(
        (baseSites: BaseSite[]) => baseSites.find((baseSite: BaseSite) => baseSite.id === this.cmsConfig.baseSite)
      ),
      map(
        (baseSite: BaseSite) => {
          return [
            {
              contactIcon: 'phone',
              contactLink: 'tel:' + baseSite.phoneNumber,
              contactHeading: baseSite.phoneNumber,
              contactDescription: baseSite.openingHours
            },
            {
              contactIcon: 'email',
              contactLink: 'mailto:' + baseSite.supportEmail,
              contactHeading: baseSite.supportEmail,
              contactDescription: this.translateService.instant('contact.contactBox.email.description')
            },
            {
              contactIcon: 'formular',
              contactLink: '/' + this.cmsConfig.routes?.faqBaseRoute + '/' + this.cmsConfig.routes?.faqRoutes?.contactRoute,
              contactHeading: this.translateService.instant('contact.contactBox.contactUs.headline'),
              contactDescription: this.translateService.instant('contact.contactBox.contactUs.description'),
            },
          ]
        }
      )
    );
  }

}
